import { useEffect, useState } from "react";

export const STEPS = ["Raw rubber prep", "Compound mixing", "Production floor", "Inspection", "Finishing & packing"];
export const E2E_VIDEO = "/media/process_e2e.mp4";
export const E2E_POSTER = "/media/process_e2e_poster.jpg";
const STEP_SECONDS = 4;

export const ProcessTicker = ({ videoRef, className = "" }) => {
  const [step, setStep] = useState(0);

  useEffect(() => {
    const v = videoRef.current;
    if (!v) return undefined;
    const on = () => setStep(Math.min(STEPS.length - 1, Math.floor(v.currentTime / STEP_SECONDS)));
    v.addEventListener("timeupdate", on);
    return () => v.removeEventListener("timeupdate", on);
  }, [videoRef]);

  return (
    <div data-testid="process-ticker" className={`border border-white/15 bg-[#07090e]/60 px-4 py-3 backdrop-blur-md ${className}`}>
      <div className="flex items-center justify-between gap-6">
        <p className="font-mono-x flex items-center gap-2 text-[10px] uppercase tracking-[0.2em] text-sky-300">
          <span className="h-1.5 w-1.5 animate-pulse rounded-full bg-red-500" /> End-to-end process
        </p>
        <p className="font-mono-x text-[10px] text-slate-300">0{step + 1} / 0{STEPS.length}</p>
      </div>
      <p data-testid="process-ticker-step" className="font-display mt-1 text-xl font-bold uppercase text-white">{STEPS[step]}</p>
      <div className="mt-2 grid grid-cols-5 gap-1">
        {STEPS.map((s, i) => (
          <span key={s} className={`h-[3px] transition-colors duration-500 ${i <= step ? "bg-sky-400" : "bg-white/20"}`} />
        ))}
      </div>
    </div>
  );
};
